const resolveText = (text, state = {}) => {
    if (text == null) return null;
    Object.keys(state).map((key) => {
      let regex = new RegExp(`{${key}}`, "g");
      text = text.replace(
        regex,
        typeof state[key] === typeof []
          ? state[key].map((v) => v.toLowerCase()).join(", ")
          : key === "name"
          ? `${state[key].charAt(0).toUpperCase()}${state[key].slice(1)}`
          : state[key]
      );
      return null;
    });
    return text;
  },
  resolveEmotionCases = (cases = [], global = {}, single = false) => {
    let items = cases.length
      ? cases.filter((caseItem) => {
          let { key, match, value } = caseItem,
            globalValue = global[key];
          if (globalValue && match === "EXACT") return globalValue[0] === value;
          else return false;
        })
      : [];
    if (single) return items.length > 0 ? items[0] : null;
    return items;
  },
  resolveGuideCases = (cases = [], state = []) => {
    const items = [],
      stateOptions = state.length;
    cases.map((item) => {
      const { key, match, value } = item,
        keyExists = items.find((val) => val.key === key);
      if (keyExists != null) return null;
      if (match === "PARTIAL") {
        let values = JSON.parse(value),
          options = values.filter((val) => !val).length,
          matched = values
            .map((val, index) => val && (val === state[index] || val === "?"))
            .filter((val) => val);
        if (matched.length === options) items.push(item);
      } else if (match.includes("PERCENT_MIN_")) {
        let percent = parseInt(match.split("PERCENT_MIN_")[1]),
          matched = state.filter((val) => val === value).length,
          percentage = parseFloat(
            (parseFloat((matched / stateOptions).toFixed(2)) * 100).toFixed(2)
          );
        if (percentage >= percent) items.push(item);
      }
      return null;
    });
    return items;
  },
  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  },
  formatTime = (seconds) => {
    let minutes = parseInt(seconds / 60),
      second = parseInt(seconds % 60);
    if (isNaN(minutes)) minutes = 0;
    if (isNaN(second)) second = 0;
    return `${minutes.toString().padStart(2, "0")}:${second
      .toString()
      .padStart(2, "0")}`;
  };

const common = {
  resolveText,
  resolveEmotionCases,
  resolveGuideCases,
  sleep,
  formatTime,
};

export default common;
